import { SrMembership, SrPendingLink } from '@cloudsign/shared';
import { z } from 'zod';

export { SrAccept, SrBuildingTotals, SrConsent, SrMembership, SrMembershipUpdate, SrPendingLink, SrResume } from '@cloudsign/shared';

/** Tenant routes of the module (docs/modules/shared-reception.md s5, "Tenant"). */
export const BASE = '/shared-reception';
export const MEMBERSHIPS = `${BASE}/memberships`;

export const MembershipArray = z.array(SrMembership);

/** New shared tablets waiting for this company's approval (SECSR1). */
export const PENDING_LINKS = `${MEMBERSHIPS}/pending-links`;
export const PendingLinkArray = z.array(SrPendingLink);

export const keys = {
  memberships: ['shared-reception', 'memberships'] as const,
  pending: ['shared-reception', 'pending-links'] as const,
  consent: (version: number) => ['shared-reception', 'consent', version] as const,
  totals: (siteId: string) => ['shared-reception', 'totals', siteId] as const,
};

/** Memberships the company is still part of. */
export const JOINED: readonly string[] = ['active', 'paused', 'leaving'];
export const PAST: readonly string[] = ['left', 'declined', 'withdrawn'];

export const statusTone = (s: string): 'neutral' | 'good' | 'warn' | 'bad' =>
  s === 'active' ? 'good' : s === 'paused' || s === 'leaving' || s === 'invited' ? 'warn' : 'neutral';
